import './index.css';
import { Logger } from './application/Logging/Logger';
import { renderApp as renderProApp } from './index.production';
import { unregister } from './registerServiceWorker';
import { isProduction } from './config/env';
// Shared components library CSS
import '@ael/shared-components-library/src/index.scss';
import 'uno.css';

import './styles/css/editor.scss';

const rootElement: HTMLElement = document.getElementById('root') as HTMLElement;

renderProApp(rootElement);

// After first paint: telemetry is worth nothing that is worth delaying the first frame for.
window.requestAnimationFrame(() => {
  window.setTimeout(() => Logger.initialize(), 0);
});

if (isProduction) {
  unregister();
}
